import {
  getMyProfileApiUsersMeGetOptions,
  getMyProfileApiUsersMeGetQueryKey,
  getPublicProfileApiUsersProfilesUserIdGetOptions,
  getPublicProfilesApiUsersProfilesGetOptions,
  getPublicProfilesApiUsersProfilesGetQueryKey,
  updateMyProfileApiUsersMePatchMutation,
} from '@/api/@tanstack/react-query.gen'
import { Options } from '@/api/sdk.gen'
import type {
  UpdateMyProfileApiUsersMePatchData,
  UpdateMyProfileApiUsersMePatchError,
  UpdateMyProfileApiUsersMePatchResponse,
} from '@/api/types.gen'
import { useMutation, UseMutationOptions, useQuery } from '@tanstack/react-query'
import queryClient from './queryClient'

interface GetPublicProfilesParams {
  search?: string
  limit?: number
}

// Get public profiles with optional search
export const useGetPublicProfiles = ({ search, limit = 20 }: GetPublicProfilesParams = {}) => {
  return useQuery(
    getPublicProfilesApiUsersProfilesGetOptions({
      query: {
        search,
        limit,
      },
    }),
  )
}

// Get a public profile by user ID
export const useGetPublicProfile = (userId: string) => {
  return useQuery({
    ...getPublicProfileApiUsersProfilesUserIdGetOptions({
      path: { user_id: userId },
    }),
    enabled: !!userId,
  })
}

// Get current user's profile
export const useGetMyProfile = () => {
  return useQuery(getMyProfileApiUsersMeGetOptions())
}

// Update current user's profile
export const useUpdateMyProfile = (
  options?: UseMutationOptions<
    UpdateMyProfileApiUsersMePatchResponse,
    UpdateMyProfileApiUsersMePatchError,
    Options<UpdateMyProfileApiUsersMePatchData>
  >,
) => {
  return useMutation({
    ...options,
    ...updateMyProfileApiUsersMePatchMutation(),
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      queryClient.invalidateQueries({ queryKey: getMyProfileApiUsersMeGetQueryKey() })
      queryClient.invalidateQueries({ queryKey: getPublicProfilesApiUsersProfilesGetQueryKey() })
    },
  })
}
